import { schema } from 'normalizr'

const deliveryProductImage = new schema.Entity('deliveryProductImages')

export default deliveryProductImage
